import React from 'react';
import CandidateTable from './CandidateTable'; // Import the shared component

const PublicApplicationsTable = (props) => {
    return <CandidateTable {...props} tableType="public" />;
};

export default PublicApplicationsTable;